import React from 'react';

export interface IconInfoProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconInfo: React.FC<IconInfoProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M11.1667 11.1667L11.2128 11.1437C11.8496 10.8252 12.5666 11.4003 12.3939 12.0911L11.6061 15.2422C11.4334 15.933 12.1504 16.5081 12.7872 16.1897L12.8333 16.1667M22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12C2 6.47716 6.47716 2 12 2C17.5229 2 22 6.47716 22 12ZM12 7.83333H12.0083V7.84167H12V7.83333Z" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="square" />  
    </svg>
  );
};

export default IconInfo;
